import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import autocomplete, {AutocompleteResult} from "autocompleter/autocomplete";

import Fragment from "dce-fragments/lib/fragments/Fragment";
import findFragmentParent from "dce-fragments/lib/fragments/utils/findFragmentParent"

interface AutocompleteFieldProps {
    wireAction: string;
    minLength: number
}



@Dce("AutocompleteField")
export default class AutocompleteField extends DceComponent<AutocompleteFieldProps> {

    private input: HTMLInputElement;

    private parentFragment: Fragment;
    private ac: AutocompleteResult;

    constructor(elem: DceHTMLElement, props: AutocompleteFieldProps) {
        super(elem, props);

        //znalezienie parenta ktory jest fragmentem
        this.parentFragment = findFragmentParent(elem);

        console.log("PF", this.parentFragment);

        let s = "abc123!?$*&()'-=@~s";
        console.log("BTOA", btoa(s));

        this.input = this.elem as unknown as HTMLInputElement

        this.ac = autocomplete({
            preventSubmit: true,
            disableAutoSelect: true,
            minLength: this.props.minLength,
            input: this.input,
            fetch: async (text, update) => {
                text = text.toLowerCase();

                let resp = await this.parentFragment.call(
                    this.props.wireAction,
                    {
                        query: text
                    },
                    true
                )

                let d: string[] = [];

                if(resp.hasData("suggest")){
                    d = resp.data['suggest'];
                }

                var suggestions = d.map(a => {
                        return {
                            label: a
                        };
                    });

                update(suggestions);
            },
            onSelect: item => {
                this.input.value = item.label;
            }
        });

    }


    defaultProps(): AutocompleteFieldProps {
        return {
            minLength: 2,
            wireAction: ""
        };
    }

    onRemove() {
        if(this.ac){
            this.ac.destroy();
        }
    }
}
